<template>
  <div class="diagnostic-section">
    <div v-for="(ques, index) in getCurrentSection.questions" :key="index">
      <h1
        v-if="selectedQuestionId === ques.questionId || currentPage === firstIndex"
        class="diagnostic-question-title"
      >
        {{ ques.stepQuestion }}
      </h1>
      <div
        v-if="selectedQuestionId === ques.questionId || currentPage === firstIndex"
        class="row diagnostic-answers-container"
      >
        <div v-for="(answer, ansIndex) in ques.answers" :key="ansIndex" class="col-sm-6 col-md-3">
          <div
            v-if="answer.choiceImage"
            class="diagnostic-option-img-box"
            @click="goToSections(answer)"
          >
            <div class="diagnostic-image-container">
              <img :src="answer.choiceImage.Src" :alt="answer.choiceImage.Alt" />
            </div>
            <div class="diagnostic-option-text-box">
              <span class="diagnostic-option-text">{{ answer.choiceTitle }}</span>
            </div>
          </div>
          <div
            v-else
            class="diagnostic-option-text-container"
            style="background-color: white"
            @click="goToSections(answer)"
          >
            <span class="diagnostic-option-text">{{ answer.choiceTitle }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="diagnostic-section-pagination">
      <ul class="diagnostic-section-dot-container">
        <li
          v-for="(section, index) in getSectionList"
          :key="index"
          class="diagnostic-section-dot"
          :class="{ 'diagnostic-section-dot--active': index === currentPage }"
        >
          <button class="diagnostic-section-dot-inner"></button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'product-diagnostic',
  props: {
    initialdata: { type: Array, required: true },
  },
  data() {
    return {
      currentPage: 0,
      selectedQuestionId: '',
      productResults: [],
      firstIndex: 0,
    };
  },
  computed: {
    getSectionList() {
      const sectionsList = this.initialdata ? this.initialdata[0].sections : [];
      return sectionsList;
    },
    getCurrentSection() {
      return this.getSectionList[this.currentPage];
    },
  },
  mounted() {
    this.dataLayerCall('true');
  },
  methods: {
    goToSections(answer) {
      if (answer.choiceDescription) {
          dataLayer.push({ //eslint-disable-line
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'augmented products',
          eventAction: `diagnosis::${this.currentPage + 1}::${this.getCurrentSection.questions[0].stepQuestion.toLowerCase()}`,
          eventLabel: `${answer.choiceDescription.toLowerCase()}`,
        });
      }
      if (answer.nextQuestion) {
        this.currentPage = this.currentPage + 1;
        this.selectedQuestionId = answer.nextQuestion;
        this.dataLayerCall('true');
      } else {
        this.dataLayerCall('false');
        this.productResults = answer.result;
        this.$emit('show-diagnostic', this.productResults);
      }
    },
    resetData() {
      this.currentPage = 0;
      this.selectedQuestionId = '';
      this.productResults = [];
    },
    dataLayerCall(value) {
      if (value === 'true') {
        const questionName = this.getCurrentSection.questions[0].stepQuestion;
        const currentPage = this.currentPage + 1;
        dataLayer.forEach((el) => {
          if (el.pageCategory === 'content page::augmented products') {
            el['event'] = 'updatevirtualpath';
            el['virtualPageTitle'] = `/${[questionName.toLowerCase()] + 'step' + currentPage}`;
            el['virtualPageURL'] = `/${[questionName.toLowerCase()] + '-step' + currentPage}`;
          }
        });
      } else {
        dataLayer.forEach((el) => {
          if (el.pageCategory === 'content page::augmented products') {
            el['event'] = 'updatevirtualpath';
            el['virtualPageTitle'] = '/diagnosis recommended routine';
            el['virtualPageURL'] = '/diagnosis-recommended-routine';
          }
        });
      }
    },
  },
};
</script>
